import BaseStore from '@src/utils/store/base-store';
import { getOmniData, Ids } from '@src/services/omni-api';
import useMount from '@src/utils/hooks/use-mount';
import { observable } from 'mobx';
import { DOWNLOAD_URL } from '@src/constants/business';
import AntdMessage from '@src/components/antd/message';

export default class extends BaseStore {
  #name = 'KvSectionStore';

  @observable downloadLink = DOWNLOAD_URL;

  @observable kvInfo;

  onDownloadClick = () => {
    if (this.downloadLink) {
      window.open(this.downloadLink, '_blank');
    } else {
      AntdMessage.info('敬请期待');
    }
  };

  constructor(props) {
    super();

    Object.assign(this, props);
  }

  // 获取KV信息
  getKvInfo = async () => {
    try {
      const res = await getOmniData(Ids.kv.channel, [
        {
          dataSourceId: Ids.kv.dataSources.kv || ''
        }
      ]);
      // const items = res[Ids.kv.dataSources.kv].result?.items;
      // 设置首屏KV数据 ds_cat_eee26b99
      const kvData = res?.[Ids.kv.dataSources.kv]?.result?.items || [];
      // console.log(kvData);
      this.kvInfo = {
        kv: kvData?.[0]?.kv_image?.[0]?.url || '',
        template: kvData?.[0]?.template || ''
      };
      // console.log(res);
    } catch (error) {
      console.log(error);
      AntdMessage.error(error);
    }
  };

  use() {
    super.use();
    useMount(() => {
      this.getKvInfo();
    });
  }
}
